module.exports = __webpack_public_path__ + "static/media/029.8df3e04c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/029.jpg
// module id = 326
// module chunks = 0